module.exports = __webpack_public_path__ + "static/media/addAttachment.a2b0f073.png";